import TextContentTranslationResourcePagingResultModel from '../../generated/types/model/resource/TextContentTranslationResourcePagingResultModel';

export default class TextContentTranslationResourcePagingResultViewModel extends TextContentTranslationResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
